import instance from '@/services/repository';

const resource = '/taskinstructions';

export default {
    getAll() {
        return instance.get<ITaskInstruction[]>(`${resource}`);
    },
    download(key: string) {
        return instance
            .get<Blob>(`${resource}/${key}`, { responseType: 'blob' });
    },
};
